import { initModule } from './init-module';

initModule();

export { CommunicationLibraryRoutes } from './communication-library.routes';

export { communicationLibrary } from './communication-library.config';

export { cpRoutesMap } from './init-module';

export { CommunicationLibraryComponent } from './components/communications/communication-library.component';
